import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'K-Privilege';
  constructor(private translateService: TranslocoService) {
    const langStore = localStorage.getItem('lang');
    if (langStore) {
      this.translateService.setActiveLang(langStore);
    }
  }
}
